import Vue from "vue";
import api from "@/api";

const BOOKS_LIMIT = 10;

const state = {
  books: [],
  trending: {
    loading: false,
    error: null,
    bookIds: []
  },
  category: {
    items: [],
    selected: null,
    trending: {
      loading: false,
      error: null,
      bookIds: []
    },
    latest: {
      loading: false,
      error: null,
      bookIds: []
    }
  }
};

const getters = {
  books: (state) => (type) => {
    return state.books.filter(a => state[type].bookIds.includes(a.id));
  },
  categoryBooks: (state) => (type) => {
    return state.books.filter(a => state.category[type].bookIds.includes(a.id));
  },
  bookIds: (state) => {
    return state.books.map(a => a.id);
  },
  categories: (state) => {
    return state.category.items;
  },
  currentCategory: (state, getters) => {
    return getters.categories.find(a => a.slug === state.category.selected);
  },
  currentCategorySlug: (state, getters) => {
    return getters["currentCategory"] && getters["currentCategory"].slug;
  },
  currentCategoryTitle: (state, getters) => {
    return getters["currentCategory"] && getters["currentCategory"].title;
  }
};

const mutations = {
  books: (state, payload) => {
    Vue.set(state, "books", [...state.books, ...payload]);
  },
  categories: (state, payload) => {
    Vue.set(state.category, "items", payload);
  },
  selectCategory: (state, payload) => {
    Vue.set(state.category, "selected", payload);
  },
  action: (state, { type, isCategory, action, value }) => {
    Vue.set((isCategory ? state.category : state)[type], action, value);
  }
};

const actions = {
  fetch: ({ commit, dispatch }, { type, categorySlug }) => {
    const isCategory = !!categorySlug;
    commit("action", { action: "loading", type, isCategory, value: true });
    return api.books[type]({ categorySlug, limit: BOOKS_LIMIT })
      .then(res => {
        dispatch("books", res.books);
        const bookIds = res.books.map(a => a.id);
        commit("action", { action: "bookIds", type, isCategory, value: bookIds });
        commit("action", { action: "error", type, isCategory, value: false });
      })
      .catch((err) => {
        commit("action", { action: "error", type, isCategory, value: err });
      })
      .finally(() => {
        commit("action", { action: "loading", type, isCategory, value: false });
      });
  },
  categories: ({ dispatch, commit }, { categories, categorySlug }) => {
    if (!categorySlug) {
      categorySlug = categories[0].slug;
    }
    // Shift defined category to top of list
    const index = categories.findIndex(a => a.slug === categorySlug);
    const item = categories[index];
    categories.splice(index, 1);
    categories.unshift(item);
    commit("categories", categories);
    dispatch("category", item.slug);
  },
  category: ({ commit, dispatch }, categorySlug) => {
    commit("selectCategory", categorySlug);
    dispatch("fetch", { type: "trending", categorySlug });
    dispatch("fetch", { type: "latest", categorySlug });
  },
  books: ({ commit, getters }, payload) => {
    // Prevent book duplication
    const books = payload.filter(a => !getters.bookIds.includes(a.id));

    commit("books", books);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
